export default "__VITE_ASSET__DVmdWOwt__"